import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';


const valueFormatter = (value: number | null) => `${value}mm`;

export default function HorizontalBars(props : any) {
    const chartSet = props.chartSetting;
    var dataset = props.dataset;
    var series = props.series;
  


  return (
    <BarChart
      borderRadius={10}
      margin={{ left: 50, right:20 }}
      dataset={dataset}
      yAxis={[{ 
        scaleType: 'band', 
        dataKey: 'month',
        categoryGapRatio: 0.5,
        barGapRatio: 1
      }]}
      series={series}
      slotProps={{legend:{position:{vertical:'bottom'}, }}}
      layout="horizontal"
      colors={[
        '#ffa13d',
        '#ff4545',
        '#ffd600',
        '#ca74ff',
      ]}  
      {...chartSet}
      tooltip={{trigger:'none'}}


      
    />
  );
}


/*

      yAxis={[{ scaleType: 'band', dataKey: 'month' }]}
      series={[{ dataKey: 'seoul', label: 'Seoul rainfall', valueFormatter },
      { dataKey: 'newYork', label: 'bf', valueFormatter }
    ]}
      layout="horizontal"
      {...chartSetting}
*/